<template>
    <announcement-common></announcement-common>
</template>
<script>
import announcementCommon from './announcementCommon.vue';

export default {
    name: 'announcementEdit',
    components: {
        announcementCommon,
    },
};
</script>
